












import { SelectOption } from "@/data/models/select-option.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import { Component, Inject, Vue } from "vue-property-decorator";
import packageInfo from "../../../package.json";

@Component
export default class Commissioni extends Vue {
  @Inject("AnagraficaService") anagraficaService!: AnagraficaService;

  commissioni: SelectOption[] = [];
  loading: boolean = true;
  hide: boolean = false;
  base!: string;

  loadElenchi() {
    this.anagraficaService
      .getMenu("commissione")
      .then((result) => {
        this.commissioni = result;
      })
      .finally(() => (this.loading = false));
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);

    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const path = location.pathname;
    this.hide = params.get("id") != undefined && params.get("id") != "";
    if (params) {
      this.base = path + "?" + uri + "&id=";
    } else {
      this.base = path + "?id=";
    }
    this.loadElenchi();
  }
}
